import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAnalytics } from 'firebase/analytics';
import { getRemoteConfig } from 'firebase/remote-config';
import settings from '../config/settings';

const firebaseApp = initializeApp(settings.firebaseConfig);

if (process.env.NODE_ENV === 'production') {
  getAnalytics(firebaseApp);
}

if (process.env.NODE_ENV === 'development') {
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = 'B7BDA0AD-3557-44B5-8681-73BA5665F604';
}

if (settings.recaptchaSiteKey) {
  initializeAppCheck(firebaseApp, {
    provider: new ReCaptchaV3Provider(settings.recaptchaSiteKey),
    isTokenAutoRefreshEnabled: true,
  });
}

export const remoteConfig = getRemoteConfig(firebaseApp);
